import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=ef85c65c&scoped=true"
import script from "./AppDrawer.vue?vue&type=script&lang=js"
export * from "./AppDrawer.vue?vue&type=script&lang=js"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=ef85c65c&prod&scoped=true&lang=css"
import style1 from "./AppDrawer.vue?vue&type=style&index=1&id=ef85c65c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef85c65c",
  null
  
)

export default component.exports